import { Component, h, Method, Prop, State } from '@stencil/core';

@Component({
  tag: 'toast-notification',
  shadow: false,
  styleUrl: 'toast-notification.css',
  assetsDirs: ['assets'],
})
export class ToastNotification {
  @Prop() imagotipo = 'imagotipo-blanco.png';
  @Prop() typeToast: string;

  @State() typeToastElement: string;

  toastElement: HTMLDivElement;
  bootstrapToast: any;
  titleToast: string;
  messageToast: string;
  classHeaderToast: string;
  textColorToast: string;
  iconToast: string;
  colorToast: string;

  componentDidLoad() {
    this.bootstrapToast = new (window as any).bootstrap.Toast(this.toastElement);
  }

  componentWillLoad() {
    this.typeToastElement = this.typeToast;
    this.messageAlert(this.typeToastElement);
  }

  @Method()
  async show(type?: string) {
    if (type) {
      this.typeToastElement = type;
      this.messageAlert(type);
    }
    if (this.bootstrapToast) {
      this.bootstrapToast.show();
    }
  }

  messageAlert(type: string) {
    switch (type) {
      case 'success':
        this.titleToast = 'Información guardada';
        this.messageToast = 'Se ha guardado correctamente la información.';
        this.classHeaderToast = 'bg-success';
        this.textColorToast = 'text-success';
        this.iconToast = 'bi-check-circle';
        this.colorToast = 'success';

        break;
      case 'danger':
        this.titleToast = 'Error al guardar la información';
        this.messageToast = 'No se ha podido guardar la información, vuelva a intentar.';
        this.classHeaderToast = 'bg-danger';
        this.textColorToast = 'text-danger';
        this.iconToast = 'bi-x-circle';
        this.colorToast = 'danger';
        break;
      case 'no-valid':
        this.titleToast = 'Información no válida';
        this.messageToast = 'Los datos ingresados no son válidos o falta información por ingresar, por favor revise e intente nuevamente.';
        this.classHeaderToast = 'bg-warning';
        this.textColorToast = 'text-warning';
        this.iconToast = 'bi-exclamation-circle';
        this.colorToast = 'warning';
        break;
      case 'in-progress':
        this.titleToast = 'Validando información';
        this.messageToast = 'Por favor espere mientras se valida la información ingresada.';
        this.classHeaderToast = 'bg-info';
        this.textColorToast = 'text-info';
        this.iconToast = 'bi-clock';
        this.colorToast = 'info';
        break;
      default:
        this.titleToast = 'Servicio no disponible';
        this.messageToast = 'Contacte al administrador.';
        this.classHeaderToast = 'bg-warning';
        this.textColorToast = 'text-warning';
        this.iconToast = 'bi-exclamation-triangle';
        this.colorToast = 'warning';
        break;
    }
  }

  render() {
    /* const imageSrc = getAssetPath(`/assets/img/logos/${this.imagotipo}`); */
    return (
      <div aria-live="polite" aria-atomic="true" class="position-relative">
        <div class="toast-container position-fixed top-0 start-50 translate-middle-x p-3">
          <div
            id="liveToast"
            class="colored-toast toast row"
            style={{ border: `1px solid var(--bs-${this.colorToast})` }}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            ref={el => (this.toastElement = el as HTMLDivElement)}
          >
            <button
              type="button"
              class="close-toast position-absolute p-1 rounded-circle"
              data-bs-dismiss="toast"
              aria-label="Close"
            >
              <i class="bi bi-x-lg text-white"></i>
            </button>
            <div class="col-2 justify-content-center align-items-center d-flex">
              <i class={`fs-2 bi ${this.iconToast} ${this.textColorToast}`}></i>
            </div>
            <div class="col-10 toast-body">
              <p class="fs-6 fw-bold text-secondary"> {this.titleToast} </p>
              <div class=" fs-6 fw-medium text-secondary">{this.messageToast}</div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
